import React from 'react'
import Header from '../inc/Header';
import {Link} from "react-router-dom";
import maingatelodge from "../images/berhamporelodgebest.jpg";

function About() {
  return (
    <div>
        <Header/>
        <br/>
        <br/>
        <br/>
        <br/>
      
        <div className='hotelberhamporelodge'>
         <div className="album py-1">
                <div className="container">
                  <div className="row">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li  className="breadcrumb-item"><Link to="/" style={{color:"white"}} href="#">Home</Link></li>
                        <li style={{color:"white"}} className="breadcrumb-item active" aria-current="page">About us</li>
                      </ol>
                    </nav>
                  </div>
                </div>
                </div>
              </div>
              <br/>
         <div className="album py-0">
        <div className="container">
            <h1><b>Berhampore Lodge <b style={{color:"#c0942e"}}>About us</b> </b></h1>
            </div>
        </div>
              <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-8 mt-3">
<h6 className="textjustify mt-0"><b>Berhampore Lodge </b>is a centrally located hotel and lodge in Berhampore (Murshidabad), West Bengal, India, positioned on R.N. Tagore Road near Laldighi. The property is known as one of the established lodging options in the city, offering accommodation and hospitality services for travelers visiting Murshidabad.</h6>
<h5><b>🏨 What the Hotel Offers</b></h5>
<h6 className='textjustify'>A comfortable stay with basic hotel amenities and services suitable for both short and longer stays.</h6>
<h6 className='textjustify'>Standard services typically include air-conditioned rooms, room service, housekeeping, laundry service, and amenities like parking and free Wi-Fi.</h6>
<h6 className='textjustify'>Guests can generally expect a restaurant and bar facilities on site.
</h6>
<h6 className='textjustify'>Positioned conveniently close to transportation hubs like the Berhampore Court Railway Station, making it a practical choice for travelers.</h6>
<h6 className='textjustify'>
  This spot places it near local attractions and essential city landmarks, making it suitable for tourists and business visitors alike.
</h6>
                </div>
                   <div className="col-md-4 mt-3">
      <img src={maingatelodge} class="d-block w-100" alt="Berhampore Lodge"/>

                </div>
                </div>
                </div>
                
            </div>
            <br/>
    </div>
  )
}

export default About